import { render, staticRenderFns } from "./DormBranch.vue?vue&type=template&id=60dc2f0f&scoped=true&"
import script from "./DormBranch.vue?vue&type=script&lang=js&"
export * from "./DormBranch.vue?vue&type=script&lang=js&"
import style0 from "./DormBranch.vue?vue&type=style&index=0&id=60dc2f0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dc2f0f",
  null
  
)

export default component.exports